import React from 'react'
import styles from '../../styles/MenuDetail.module.css'
import { Link as ScrollLink, Element } from 'react-scroll';
import { Breadcrumbs } from '../../components/Breadcrumb'

const EyesEyelid = () => {
  return (
    <>
        <section className={styles.fv_area}>
            <h2>まぶたの脂肪取り</h2>
        </section>
        <Breadcrumbs />

        <section className={styles.jump_link_area}>
            <ul>
                <li>
                    <ScrollLink to="target" smooth={true}>おすすめの方</ScrollLink>
                </li>
                <li>
                    <ScrollLink to="flow" smooth={true}>施術の流れ</ScrollLink>
                </li>
                {/* <li>
                    <ScrollLink to="case" smooth={true}>症例写真</ScrollLink>
                </li> */}
                <li>
                    <ScrollLink to="price" smooth={true}>料金</ScrollLink>
                </li>
            </ul>
        </section>

        <Element className={styles.about_area} name='target'>
            <h2>まぶたの脂肪取りとは</h2>
            <p>
                日本人はもともとまぶたの皮膚が厚く、皮下脂肪が多いのが特徴です。<br />
                そのためまぶたが腫れぼったく見え、目つきが悪い、不機嫌そうな目に見られてしまいます。<br />
                また、まぶたの脂肪はお腹の脂肪とは違い、何らかのエクササイズで取れることはありません。<br />
                上まぶたの脂肪を減らして腫れぼったさのないまぶたにするためには、脂肪（眼窩脂肪）を直接除去するのが効果的です。<br />
                脂肪取りのみでも二重になることがございますが、二重術と合わせることで、自然で明るい印象の目元を演出できます。
            </p>
            <div className={styles.img_wrapper}>
                <img src='/images/about-area-eyes-eyelid-img.png' alt='about-area-eyes-eyelid-img' className={styles.pc_img}/>
                <img src='/images/about-area-eyes-eyelid-sp-img.png' alt='about-area-eyes-eyelid-sp-img' className={styles.sp_img}/>
            </div>
            <div className={styles.target}>
                <h3>おすすめの方</h3>
                <ul>
                    <li>
                        <img src='/images/check-icon.png' className={styles.check_icon} alt='img' />まぶたがむくみやすい方
                    </li>
                    <li>
                        <img src='/images/check-icon.png' className={styles.check_icon} alt='img' />まぶたの厚みが気になる方
                    </li>
                    <li>
                        <img src='/images/check-icon.png' className={styles.check_icon} alt='img' />二重埋没をとれにくくしたい方
                    </li>
                    <li>
                        <img src='/images/check-icon.png' className={styles.check_icon} alt='img' />脂肪をしっかりとって変化を出したい方
                    </li>
                </ul>
            </div>
        </Element>
        <Element className={styles.flow_area} name='flow'>
            <h2>施術の流れ</h2>
            <div className={styles.cards}>
                <div className={styles.card}>
                    <div>
                        <img src='/images/flow-img.png' className={styles.card_img} alt='img' />
                    </div>
                    <div>
                        <div className={styles.title}>カウンセリングで理想の瞼の状態をお伺いいたします。</div>
                        <div className={styles.text}>
                            無料カウンセリングではまず目もとの状態を確認し、患者様にあった施術をご提案いたします。
                        </div>
                    </div>
                </div>

                <div className={styles.card}>
                    <div>
                        <img src='/images/flow-img2.png' className={styles.card_img} alt='img' />
                    </div>
                    <div>
                        <div className={styles.title}>ご希望の瞼に添って施術を行います。</div>
                        <div className={styles.text}>
                            空きがあればカウンセリング当日の施術も可能です。施術時間は15-20分程度になります。<br />
                            ※施術中は局所麻酔を使用致しますので痛みはございません。
                        </div>
                    </div>
                </div>

                <div className={styles.card}>
                    <div>
                        <img src='/images/flow-img3.png' className={styles.card_img} alt='img' />
                    </div>
                    <div>
                        <div className={styles.title}>施術後はそのままお帰りいただけます。</div>
                        <div className={styles.text}>
                            施術によってはパウダールームにてお化粧しご帰宅可能です。特に通院の必要はございませんが、気になることなどございましたら、クリニックにお気軽にご連絡ください。
                        </div>
                    </div>
                </div>

            </div>
        </Element>
        {/* <Element className={styles.case_area} name='case'>
            <h2>まぶたの脂肪取りの症例写真</h2>
            <div className={styles.items}>
                <div className={styles.item}>
                    <div>
                        <img src='/images/case-area-img.png' className={styles.case_img} alt='img' />
                    </div>
                </div>
                <div className={styles.item}>
                    <div>
                        <img src='/images/case-area-img2.png' className={styles.case_img} alt='img' />
                    </div>
                </div>
                <div className={styles.item}>
                    <div>
                        <img src='/images/case-area-img3.png' className={styles.case_img} alt='img' />
                    </div>
                </div>
            </div>
        </Element> */}

        <Element className={styles.price_area} name='price'>
            <h2>料金</h2>
            <div className={styles.price_lists}>
                <div className={styles.price_list}>
                    <div>まぶたの脂肪取りスタンダード</div>
                    <div>¥85,800</div>
                </div>
                <div className={styles.price_list}>
                    <div>まぶたの脂肪取りプレミアム</div>
                    <div>¥162,800</div>
                </div>
                <ul className={styles.annotation}>
                    <li>※スタンダード：二重線に一致せず、傷も大きいので縫合が必要なこともございます。</li>
                    <li>※プレミアム：二重線に一致し、傷も数mm程度で縫合が不要です。</li>
                    <li>※料金は全て「税込」記載となります</li>
                </ul>
            </div>
            <div className={styles.supplement}>
                <div>
                    <h3>治療期間・回数</h3>
                    <p>
                        ・治療期間：1ヶ月<br />
                        ・通院：必要なし
                    </p>
                </div>
                <div>
                    <h3>リスク・副作用</h3>
                    <ul>
                        <li>・傷跡や赤み</li>
                        <li>・盛り上がりや糸の跡が残る可能性</li>
                    </ul>
                </div>
            </div>
        </Element>
    </>
  )
}

export default EyesEyelid